
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"-6 -6 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M205.85 189.4h-36.7v59.9h36.699v175.8h70.5V248.5h49.198l5.201-59.1H276.35v-33.7c0-13.9 2.801-19.5 16.301-19.5h38.199V74.9h-48.802c-52.5 0-76.099 23.1-76.099 67.3-.099 38.6-.099 47.2-.099 47.2z"}})])
          )
        }
      }
    